import clsx from 'clsx';
import React from 'react';

interface CountProps {
  count: number;
  className?: string;
}

export default function Count({ count, className = '' }: CountProps) {
  return <span className={clsx('bulleNbCotChantier', className)}>{count}</span>;
}
